import React from 'react'
import { calculateHoursAndMinutes } from '../../utils/DateTimeFormat';
import "./index.scss"
import { ReactComponent as NoShowIcon } from '../../assets/images/icons/noShowsIcon.svg';

const MovieCard = ({ film, filmIndex, handleMovieClick, selectedFilm, nextShowTime, showNextShowTime }) => {

    const getExpLogoUrl = (expDetails, experiencesLength) => {
        const experiences =
            expDetails?.images?.filter(img => img.code === "x330y50") || [];

        const expLogo = experiences.find(img => {
            const desc = img?.description?.toLowerCase() || "";

            return experiencesLength <= 1
                ? !desc.includes("right") // image without "right"
                : desc.includes("right"); // image with "right"
        });
        // console.log(expLogo, 'testing');
        return expLogo?.imageurl ? (
            <img
                src={expLogo.imageurl}
                alt={expDetails?.name}
                className={`exp-logo ${experiencesLength > 1 ? 'has-multiple-exps' : ''}`}
            />
        ) : (
            <p className="show-experience">{expDetails?.name}</p>
        );
    };

    return (
        <div key={filmIndex} className={`movies-list col-3 ${selectedFilm?.id === film.id ? 'is-selected' : ''}`}>
            <a onClick={() => handleMovieClick(film)} title={film.title}>
                <div>
                    {film.images.length > 0
                        ? film.images
                            .filter(img => img.code == 'x250y350')
                            .map(({ imageurl }) => {
                                return (
                                    <div className="img-blk">
                                        <img src={imageurl ? imageurl : ''} className="img-fluid" alt={film.title} />
                                    </div>
                                );
                            })
                        : null}
                    <aside className="cont-sec">
                        <h4>{film.title}</h4>
                        <p>
                            {film.rating && <span>{film.rating}</span>}
                            {film.rating && film.runtime && <>&nbsp;-&nbsp;</>}
                            {film.runtime && <span>{calculateHoursAndMinutes(film.runtime)}</span>}
                        </p>
                        <p className="cont-geners-sec">
                            {/* {film.runtime && film.genres.length > 0 && <>&nbsp;-&nbsp;</>} */}
                            {film.genres.map((genresData, index) => {
                                return (
                                    <span>
                                        {genresData.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} {film.genres.length - 1 == index ? '' : '/'}{' '}
                                    </span>
                                );
                            })}
                        </p>
                    </aside>
                    <div className="mov-det">
                        {film.emblems.length > 0 ? (
                            <aside className="ad-book">
                                <span>{film.emblems[0]}</span>
                            </aside>
                        ) : null}
                    </div>
                    {
                        showNextShowTime &&
                        <>
                            <div className="next-show-details">
                                {nextShowTime && nextShowTime.showTime ? (
                                    <>
                                        <p>Next Show</p>
                                        <div className="show-details">
                                            <div className="show-time">{nextShowTime.showTime}</div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="no-showtimes">
                                        {/* <img src={NoShowIcon} width={26} height={26} alt="no-show-icon"></img> */}
                                        <NoShowIcon width={26} height={26} />
                                        <p>No Shows Today</p>
                                    </div>
                                )}
                            </div>
                            <div className="showtime-experience">
                                {getExpLogoUrl(nextShowTime.experience[0], nextShowTime.experience.length)}
                                <p className={`show-experience`}>{nextShowTime.experience.length > 1 ? " + " + (nextShowTime.experience.length - 1) + " more" : ""}</p>
                            </div>
                        </>
                    }
                </div>
            </a>
        </div>
    )
}

export default MovieCard
